import { clearAuth } from 'store/slices/iamSlice';
import { dispatch } from 'store';
import { useCallback } from 'react';
import { AccessVerifiedV2 as VerificationSuccessPage } from '@karehero/llama/pwa/pages/AccessVerifiedV2/AccessVerifiedV2';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'router';
import { useOnboardingRoute } from 'hooks/useOnboardingRoute';

export const VerificationSuccess = () => {
  const navigate = useNavigate();
  const { value: onboardingRoute, isReady } = useOnboardingRoute();

  const onContinue = useCallback(() => {
    dispatch(clearAuth());
    // The flags pick the onboarding; until they load, the gate waits for them.
    navigate(isReady ? onboardingRoute : ROUTES.HOME);
  }, [isReady, navigate, onboardingRoute]);

  return <VerificationSuccessPage onContinue={onContinue} />;
};

VerificationSuccess.displayName = 'VerificationSuccess';
export default VerificationSuccess;
